import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "@heroui/react";
import { useForgotPasswordState } from "./hooks/use-forgot-password-state";
export function ForgotPassword({ onSubmit }) {
    const { canSubmit, errors, handleBackClicked, register, submitForm } = useForgotPasswordState();
    const [isLoading, setIsLoading] = useState(false);
    const onSubmission = async (data) => {
        setIsLoading(true);
        try {
            await onSubmit(data);
        }
        finally {
            setIsLoading(false);
        }
    };
    return (React.createElement("div", { className: "w-[90%] md:w-[70%] lg:w-[43rem] flex flex-col justify-center items-center gap-4" },
        React.createElement("div", { className: "w-full rounded-2xl shadow-lg shadow-light-gray p-8" },
            React.createElement("div", null,
                React.createElement("button", { className: "rounded-full border border-light-gray p-2", onClick: handleBackClicked },
                    React.createElement("div", null,
                        React.createElement(Icon, { className: "text-2xl", icon: "lucide:arrow-left" })))),
            React.createElement("div", { className: "flex justify-center text-center text-2xl font-semibold pt-8 pb-2" }, "Forgot Password"),
            React.createElement("div", { className: "flex justify-center text-center text-dark-gray py-4" }, "Enter your email and choose how to receive your verification code."),
            React.createElement("form", { className: "flex flex-col gap-4 py-4", onSubmit: submitForm(onSubmission) },
                React.createElement("div", { className: "grow" },
                    React.createElement("input", { className: "w-full rounded-xl bg-light-gray px-8 py-4", ...register("email", {
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Please enter a valid email address",
                            },
                            required: { value: true, message: "Please provide your email address" },
                        }), placeholder: "Email" }),
                    errors?.email && React.createElement("div", { className: "text-xs text-error" }, errors?.email?.message?.toString() ?? null)),
                React.createElement("fieldset", { className: "flex flex-col gap-2" },
                    React.createElement("legend", { className: "font-medium" }, "Send my verification code by"),
                    React.createElement("label", { className: "flex min-h-11 items-center gap-3", htmlFor: "reset-delivery-email" },
                        React.createElement("input", { ...register("delivery_method"), type: "radio", value: "email", id: "reset-delivery-email" }),
                        React.createElement("span", null, "Email")),
                    React.createElement("label", { className: "flex min-h-11 items-center gap-3", htmlFor: "reset-delivery-sms" },
                        React.createElement("input", { ...register("delivery_method"), type: "radio", value: "sms", id: "reset-delivery-sms" }),
                        React.createElement("span", null, "SMS"))),
                React.createElement(Button, { color: "primary", size: "lg", fullWidth: true, radius: "lg", isDisabled: !canSubmit, isLoading: isLoading, type: "submit", endContent: React.createElement(Icon, { icon: "lucide:arrow-right", width: "24", height: "24" }) }, "Send OTP")))));
}
